import styled from 'styled-components';  
import HrImg from '../../img/hr-maru.png';
import Img1 from '../../img/men&redisu.png';
import Img2 from '../../img/redisu&men.png';
import Img3 from '../../img/route3.png';
import Img4 from '../../img/route4.png';
import TableLeft from './TableLeft';
import TableRight from './TableRight';
import Table from './Table';

const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`
const Header =styled.h2`
    padding: 15px;
    font-size: 1.5rem;
    background-color: orange;
    color: rgb(255, 255, 255);
    border-radius: 7px;
`
const News =styled.div`
    width: 80%;
    margin: auto;
    margin-bottom: 100px;
`
const STEM: React.VFC = () => {
  return (
    <Main>
        <p className='text-center text-2xl font-bold'>STEAM教育コース</p>
        <img className='mt-2 mb-5' src={HrImg} width={'100%'} alt='hr' />
        <News><p>物理とプログラミングをバランスよく学ぶ理数IT総合コースです。 プログラミングだけでなく、ものの仕組みを低学年のうちからしっかり学ぶことで、 高学年になった時の問題解決の幅が広がります。</p></News>
        
        {/* ******************************************************************************************************************************************************************* */}
        <Header>キンダリークラス(年長)</Header>
        <TableLeft 
            text1={'STEAM教育の５領域を総合的に学び、つくる楽しみを育むクラスです。'}
            text2={'ブロックを使って、身の回りのものなどをつくることを通して、ものの仕組みや図形、数などへの興味を養います。つくることで理論を知り、体験する活動が中心です。'}
            text3={'プログラミング領域は、簡単なロボット教材や専用ボードゲーム、タブレットなどを活用して、順序立ててプログラムを考える活動をします。'}
            src={Img1}
        />
        <Table 
            td1={'開講日'} td2={'金曜日・土曜日（月２回）　'}
            td3={'時間'} td4={'(金)15:15～16:00'}
            td5={''} td6={'(土)10:00～10:45'}
            td7={'月謝'} td8={'8,580円/月（税込）～　※管理費 880円別途'}
        />

        {/* ******************************************************************************************************************************************************************* */}
        <Header>ベーシッククラス(小１～小3)</Header>
        <TableRight
            text1={'STEAM教育の５領域を総合的に学び、つくりながら原理を体験する クラスです。'}
            text2={'ブロックや電子教材を使い、身の回りにある道具や 機械の仕組みを知り、物理や工学の基礎を学びます。'}
            text3={'タブレット やロボット教材を使ったプログラミングの学習を通して、プログ ラミングの基礎を学びオリジナルの作品を作ります。'}
            src={Img2}
        />
        <Table 
            td1={'開講日'} td2={'水曜日・土曜日（月３回）'}
            td3={'時間'} td4={'(水)15:30～16:30'}
            td5={''} td6={'(水)18:00～19:00'}
            td7={''} td8={'(土)11:15～12:15'}
            td9={'月謝'} td10={'10,780円/月（税込）～　※管理費 1,650円別途'}
        />

        {/* ******************************************************************************************************************************************************************* */}
        <Header>アドバンスクラス(小2～小4)</Header>
        <TableLeft
            text1={'STEAMの応用を学ぶクラスです。'}
            text2={'ブロックを使ったエンジニアリングの他、モーターを使いロボットの基本的な組み立てにも取り組んでもらいます。'}
            text3={'プログラミングでは、ゲームやメディアアートを制作します。'}
            src={Img3}
        />
        <Table 
            td1={'開講日'} td2={'火曜日・土曜日（月３回)'}
            td3={'時間'} td4={'(火)17:40～18:40'}
            td5={''} td6={'(土)14:30～15:30'}
            td11={'月謝'} td12={'10,780円/月（税込）～　※管理費 1,650円別途'}
        />

        {/* ******************************************************************************************************************************************************************* */}

        {/* ******************************************************************************************************************************************************************* */}
        <Header>キッズエリートクラス（小３～小４)</Header>
        <TableRight
            text1={'STEAMの知識を活用して課題を解決する力を育むクラスです。'}
            text2={'環境やエネルギー問題も学び、社会に向き合う態度も育みます。'}
            text3={'パソコンの基本操作とロボット制御も開始します。'}
            src={Img4}
        />
        <Table 
            td1={'開講日'} td2={'火曜日、水曜日、金曜日（月３,４回）'}
            td3={'時間'} td4={'(火)16:30～17:30'}
            td5={''} td6={'(水)16:45～17:45'}
            td7={''} td8={'(金)16:30～17:30'}
            td9={'月謝'} td10={'11,880円/月（税込）～　※管理費 1,650円別途'}
        />

        {/* ******************************************************************************************************************************************************************* */}
        
        {/* ******************************************************************************************************************************************************************* */}
        <Header>プログラミング＆ロボティクス 1st(小４～小６)</Header>
        <TableLeft
            text1={'物理の原理とパソコンを使ったプログラミングで、ゲーム作成やロボットの制御を行い、プログラミングの知識を楽しみながら学びます。'}
            text2={'教材ではScratchやStuduinoを用います。'}
            text3={''}
        />
        <Table 
            td1={'開講日'} td2={'土曜日（月３、４回)'}
            td3={'時間'} td4={'(土)16:00～17:00'}
            td9={'月謝'} td10={'15,180円/月（税込）～　※管理費 1,650円別途'}
        />

        {/* ******************************************************************************************************************************************************************* */}
    </Main>
    
  );
}
export default STEM;